import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class TeamSelectListComponent implements IController {
  selectedId: any;
  optionIds: any;
  excludeIds: any;
  hasMembers: boolean;
  onChange: Function;

  private teamsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private excludeKeys: any;

  /* @ngInject */
  constructor(private $log, private $teams, private $infiniteScroll) {
  }

  $onInit() {
    this.teamsRef = this.$teams();
    this.loadLimit = 20;

    this.teamsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.teamsRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  private _reload() {
    this.teamsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      hasMembers: this.hasMembers
    };
  }
}

angular
  .module('bringoz.admin.teams')
  .component('teamSelectList', {
    bindings: {
      selectedId: '<',
      optionIds: '<?',
      excludeIds: '<?',
      hasMembers: '<?',
      onChange: '&'
    },
    template: require('./team-select-list.html').default,
    controller: TeamSelectListComponent
  });
